import { AppSidebar } from "@/components/app-sidebar";
import { MainNav } from "@/components/main-nav";
import { TailwindIndicator } from "@/components/tailwind-indicator";
import { ThemeToggle } from "@/components/theme-toggle";
import { siteConfig } from "@/config/site";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import {
	Separator,
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "shadcn-ui";
import { useAuth } from "@/lib";

export const Route = createFileRoute("/_auth")({
	component: AppComponent,
});

function AppComponent() {

	useAuth()

	return (
		<Outlet />
	)
}
